// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Studies bucketed by recent ingestion-run pass rate. Only studies with at least one finished, non-dry run inside the health window are counted, so the buckets sum to studies actively receiving data (not the whole portfolio).
 * @export
 * @interface GetStatistics200ResponseStudiesHealth
 */
export interface GetStatistics200ResponseStudiesHealth {
    /**
     * Studies with pass rate < 50% (more failed runs than passed)
     * @type {number}
     * @memberof GetStatistics200ResponseStudiesHealth
     */
    atRisk: number;
    /**
     * Studies with pass rate > 90%
     * @type {number}
     * @memberof GetStatistics200ResponseStudiesHealth
     */
    healthy: number;
    /**
     * Studies with pass rate between 50% and 90% inclusive
     * @type {number}
     * @memberof GetStatistics200ResponseStudiesHealth
     */
    watch: number;
}

/**
 * Check if a given object implements the GetStatistics200ResponseStudiesHealth interface.
 */
export function instanceOfGetStatistics200ResponseStudiesHealth(value: object): value is GetStatistics200ResponseStudiesHealth {
    if (!('atRisk' in value) || value['atRisk'] === undefined) return false;
    if (!('healthy' in value) || value['healthy'] === undefined) return false;
    if (!('watch' in value) || value['watch'] === undefined) return false;
    return true;
}

export function GetStatistics200ResponseStudiesHealthFromJSON(json: any): GetStatistics200ResponseStudiesHealth {
    return GetStatistics200ResponseStudiesHealthFromJSONTyped(json, false);
}

export function GetStatistics200ResponseStudiesHealthFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStatistics200ResponseStudiesHealth {
    if (json == null) {
        return json;
    }
    return {
        
        'atRisk': json['atRisk'],
        'healthy': json['healthy'],
        'watch': json['watch'],
    };
}

export function GetStatistics200ResponseStudiesHealthToJSON(json: any): GetStatistics200ResponseStudiesHealth {
    return GetStatistics200ResponseStudiesHealthToJSONTyped(json, false);
}

export function GetStatistics200ResponseStudiesHealthToJSONTyped(value?: GetStatistics200ResponseStudiesHealth | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'atRisk': value['atRisk'],
        'healthy': value['healthy'],
        'watch': value['watch'],
    };
}
